module.exports = __webpack_public_path__ + "img/base_nature_terroir.04cb869d.svg";